<template>
  <div class="photo-and-text">
      <div class="row d-flex justify-content-center align-items-center">
        <div class="mb-5 col-lg-4 col-12" v-for="item in photos" :key="item.img" >
          <img :src="item.img" :alt="item.alt">
        </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'PhotoLine',
  props: {
    photos: Array,
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Lサイズ、ワイドスクリーン : Large Devices, Wide Screens */
img {
  width: 85%;
}
@media only screen and (min-width : 992px) {
 
  img {
    object-fit: cover;
    width: 280px;
    height: 210px;
  }
}
@media only screen and (min-width : 1200px) {
 
  img {
    width: 360px;
    height: 270px;
  }
}

</style>
